import React, { useState, useEffect } from 'react';
import { Badge } from '../ui/badge';
import { Loader2} from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const AuditLogView = ({ token, lang }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/audit-logs?limit=50`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        setLogs(data.logs || []);
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  const getActionBadge = (action) => {
    const colors = {
      create: 'bg-green-100 text-green-800',
      update: 'bg-blue-100 text-blue-800',
      delete: 'bg-red-100 text-red-800',
      approve: 'bg-purple-100 text-purple-800',
      publish: 'bg-indigo-100 text-indigo-800',
      toggle: 'bg-yellow-100 text-yellow-800',
      submit_review: 'bg-orange-100 text-orange-800'
    };
    return <Badge className={colors[action] || 'bg-gray-700 text-white'}>{action}</Badge>;
  };

  if (loading) return <Loader2 className="w-6 h-6 animate-spin mx-auto" />;

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Journal d'audit</h2>
      <div className="bg-white rounded-lg border overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500">Date</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500">Action</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500">Type</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500">Utilisateur</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {logs.map((log, i) => (
              <tr key={i} className="hover:bg-gray-50">
                <td className="px-4 py-3 text-sm text-gray-600">
                  {new Date(log.timestamp).toLocaleString(lang)}
                </td>
                <td className="px-4 py-3">{getActionBadge(log.action)}</td>
                <td className="px-4 py-3 text-sm text-gray-600">{log.entity_type}</td>
                <td className="px-4 py-3 text-sm text-gray-600">{log.user_email}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// Users Management Component
